import * as i0 from '@angular/core';
import { Injectable, NgModule, PLATFORM_ID, Inject } from '@angular/core';
import * as i1 from '@tajer/api';
import { StorePageType, CurrencyPosition, SalesChannels } from '@tajer/api';
import { isPlatformServer } from '@angular/common';

class NgCoreService {
    constructor() { }
}
NgCoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NgCoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class NgCoreModule {
    static forRoot(environment) {
        return {
            ngModule: NgCoreModule,
            providers: [
                {
                    provide: 'env',
                    useValue: environment
                }
            ]
        };
    }
}
NgCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: NgCoreModule });
NgCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NgCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: []
                }]
        }] });

var BrandsType;
(function (BrandsType) {
    BrandsType[BrandsType["AllBrands"] = 0] = "AllBrands";
    BrandsType[BrandsType["SelectedBrands"] = 1] = "SelectedBrands";
})(BrandsType || (BrandsType = {}));
var DefaultItemsView;
(function (DefaultItemsView) {
    DefaultItemsView[DefaultItemsView["ItemsCard"] = 0] = "ItemsCard";
    DefaultItemsView[DefaultItemsView["ItemsWide"] = 1] = "ItemsWide";
})(DefaultItemsView || (DefaultItemsView = {}));
var CategoriesType;
(function (CategoriesType) {
    CategoriesType[CategoriesType["AllCategories"] = 0] = "AllCategories";
    CategoriesType[CategoriesType["SelectedCategories"] = 1] = "SelectedCategories";
})(CategoriesType || (CategoriesType = {}));
var ItemsType;
(function (ItemsType) {
    ItemsType[ItemsType["FeaturedProducts"] = 0] = "FeaturedProducts";
    ItemsType[ItemsType["LatestProducts"] = 1] = "LatestProducts";
    ItemsType[ItemsType["BestsellerProducts"] = 2] = "BestsellerProducts";
    ItemsType[ItemsType["OffersProducts"] = 3] = "OffersProducts";
    ItemsType[ItemsType["CategorizedProducts"] = 4] = "CategorizedProducts";
    ItemsType[ItemsType["SelectedProducts"] = 5] = "SelectedProducts";
})(ItemsType || (ItemsType = {}));

class StoreAppService {
    constructor(storeService) {
        this.storeService = storeService;
        this.noImageUrl = 'assets/image_default.png';
        this.defaultClientLogoUrl = this.noImageUrl;
        this.today = new Date();
        this.day = this.today.getDay();
        this.hours = this.today.getHours();
        this.minutes = this.today.getMinutes();
        this.languagesArray = [
            { name: 'En', isoCode: 'en', fullName: 'English' },
            { name: 'عربي', isoCode: 'ar', fullName: 'العربية' },
            { name: 'De', isoCode: 'de', fullName: 'Deutsch' },
            { name: 'Ms', isoCode: 'ms', fullName: 'Bahasa Melayu' },
            { name: 'Tr', isoCode: 'tr', fullName: 'Türkçe' },
            { name: 'Es', isoCode: 'es', fullName: 'Español' },
            { name: 'Fr', isoCode: 'fr', fullName: 'Français' },
            { name: 'Nl', isoCode: 'nl', fullName: 'Nederlands' },
            { name: 'So', isoCode: 'so', fullName: 'Somalia' },
        ];
    }
    get storeName() {
        return this.storeConfig.name;
    }
    get storeAbout() {
        return this.storeConfig.about;
    }
    get currentTheme() {
        return this.theme ? this.theme : this.storeConfig?.theme?.code;
    }
    set currentTheme(themCode) {
        this.theme = themCode;
    }
    get defaultImage() {
        return this.storeConfig && this.storeConfig.defaultImage ? this.storeConfig.defaultImage
            : this.noImageUrl;
    }
    get clientLogoUrl() {
        return this.storeConfig && this.storeConfig.logo ? this.storeConfig.logo
            : this.defaultClientLogoUrl;
    }
    get customerServiceInfo() {
        return this.storeConfig?.customerService;
    }
    get socialMediaInfo() {
        return this.storeConfig?.socialMedia;
    }
    get storeOptions() {
        return this.storeConfig?.options;
    }
    get configFeatures() {
        return this.storeConfig?.configFeatures;
    }
    get pages() {
        return this.storeConfig.pages;
    }
    get menuPages() {
        return this.pages ? this.pages.filter(x => x.showInMenu && x.type == StorePageType.Basic) : [];
    }
    get menuBlogPages() {
        return this.pages ? this.pages.filter(x => x.showInMenu && x.type == StorePageType.Blog) : [];
    }
    //#region Categories
    /**
     * all loaded categories
     */
    get allCategories() {
        const allCategories = this.storeConfig.categories ? this.storeConfig.categories : [];
        return allCategories;
    }
    get menuCategories() {
        const menuCategories = this.allCategories.filter(x => !x.hideFromHomeMenu);
        return menuCategories;
    }
    get mainCategories() {
        const mainCategories = this.allCategories.filter(x => x.parentId == null);
        return mainCategories;
    }
    getSubCategories(categoryId) {
        if (!categoryId) {
            return [];
        }
        return this.allCategories.filter(x => x.parentId == categoryId);
    }
    getCategoryBySlug(slug) {
        if (!slug) {
            return null;
        }
        return this.allCategories.find(x => x.slug == slug || x.slug2 == slug || x.slug3 == slug);
    }
    get isStoreHasCategories() {
        return this.allCategories?.length > 0;
    }
    //#endregion
    //#region Brands
    get allBrands() {
        const allBrands = this.storeConfig.brands ? this.storeConfig.brands : [];
        return allBrands;
    }
    get isStoreHasBrands() {
        return this.allBrands?.length > 0;
    }
    getBrandBySlug(slug) {
        if (!slug) {
            return null;
        }
        return this.allBrands.find(x => x.slug == slug || x.slug2 == slug || x.slug3 == slug);
    }
    getBrandById(brandId) {
        return this.allBrands.find(x => x.id == brandId);
    }
    //#endregion 
    get paymentTypes() {
        return this.storeConfig.paymentTypes;
    }
    /**languages */
    get isMultilingualEnabled() {
        return this.storeConfig?.languages?.length > 1;
    }
    get generateLanguagesArray() {
        let storeLanguages = [];
        this.storeConfig.languages.forEach(row => {
            let storeLang = this.languagesArray.find(x => x.isoCode == row);
            if (storeLang) {
                storeLanguages.push(storeLang);
            }
        });
        return storeLanguages;
    }
    //#region outlets
    /**
     * currentOutlet
     *  */
    get currentOutlet() {
        return this.storeConfig?.outlet;
    }
    get scheduledOrdersEnabled() {
        return this.currentOutlet?.availableForScheduledOrders;
    }
    get isMultiOutletEnabled() {
        return this.storeConfig.hasOutlets;
    }
    //#endregion
    get currnetCurrnecy() {
        let currnetCurrnecy = {};
        if (this.storeConfig && this.storeConfig.currency) {
            currnetCurrnecy = this.storeConfig?.currency;
        }
        return currnetCurrnecy;
    }
    get isCurrnetBefore() {
        return this.currnetCurrnecy.position == CurrencyPosition.Before;
    }
    get isCurrnetAfter() {
        return this.currnetCurrnecy.position == CurrencyPosition.After;
    }
    getPageDetails() {
        if (this.storeOptions.showAcceptAgreementCheckboxOnCheckout || this.storeOptions.showAcceptAgreementCheckboxOnSignup) {
            this.storeService.getStorefrontPage(this.storeConfig.id, {
                privacyPolicyPageId: this.storeOptions.privacyPolicyPageId,
                termsAndConditionsPageId: this.storeOptions.termsAndConditionsPageId,
            }).subscribe(data => {
                this.pageInfo = data;
            });
        }
    }
}
StoreAppService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StoreAppService, deps: [{ token: i1.StoreService }], target: i0.ɵɵFactoryTarget.Injectable });
StoreAppService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StoreAppService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StoreAppService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.StoreService }]; } });

class ItemListAppService {
    //#endregion
    constructor(itemService, storeAppService) {
        this.itemService = itemService;
        this.storeAppService = storeAppService;
        //#region variables
        this.items = [];
    }
    /**
     * used in ItemsList/ ItemsSlider
     * to populate the displayed items based on componentDesignOptions.itemsType
     * @param componentDesignOptions
     */
    populateDisplayedItems(componentDesignOptions, languagePosition, currencyId, stores) {
        this.items = [];
        if (componentDesignOptions?.itemsType == ItemsType.FeaturedProducts) {
            this.getFeaturedItems(componentDesignOptions?.featuredItemsNumber, languagePosition, currencyId, stores);
        }
        else if (componentDesignOptions?.itemsType == ItemsType.LatestProducts) {
            this.getLatestItems(componentDesignOptions?.latestItemsNumber, languagePosition, currencyId, stores);
        }
        else if (componentDesignOptions?.itemsType == ItemsType.BestsellerProducts) {
            this.getBestsellerItems(componentDesignOptions?.bestsellerItemsNumber, languagePosition, currencyId, stores);
        }
        else if (componentDesignOptions?.itemsType == ItemsType.OffersProducts) {
            this.getOffersItems(componentDesignOptions?.offersItemsNumber, languagePosition, currencyId, stores);
        }
        else if (componentDesignOptions?.itemsType == ItemsType.CategorizedProducts) {
            this.getItemsByCategory(componentDesignOptions?.itemsCategoryId, componentDesignOptions?.categorizedItemsNumber, languagePosition, currencyId, stores);
        }
        else if (componentDesignOptions?.itemsType == ItemsType.SelectedProducts) {
            const itemsIds = componentDesignOptions.selectedItems?.split(',');
            this.getSelectedItems(itemsIds, languagePosition, currencyId, stores);
        }
    }
    // Featured Products
    getFeaturedItems(itemsNumber, languagePosition, currencyId, stores) {
        this.items = [];
        this.loading = true;
        this.itemService[this.isMarketplace ? 'getMarketplace' : 'getList']({
            warehouseId: !this.isMarketplace ? this.storeAppService.currentOutlet?.warehouseId : null,
            branchId: !this.isMarketplace ? this.storeAppService.currentOutlet?.branchId : null,
            sorting: 'date desc',
            featuredOnly: true,
            hideOutOfStock: this.storeAppService.storeOptions?.hideOutOfStockItems,
            salesChannel: this.getSalesChannel,
            maxResultCount: itemsNumber,
            languagePosition: languagePosition ? languagePosition : 1,
            storesIds: stores,
            currencyId: currencyId,
            ids: null
        }).subscribe(data => {
            this.items = Object.assign([], data.items);
            this.loading = false;
        });
    }
    // Latest Products 
    getLatestItems(itemsNumber, languagePosition, currencyId, stores) {
        this.items = [];
        this.loading = true;
        this.itemService[this.isMarketplace ? 'getMarketplace' : 'getList']({
            warehouseId: !this.isMarketplace ? this.storeAppService.currentOutlet?.warehouseId : null,
            branchId: !this.isMarketplace ? this.storeAppService.currentOutlet?.branchId : null,
            sorting: 'date desc',
            latestOnly: true,
            hideOutOfStock: this.storeAppService.storeOptions?.hideOutOfStockItems,
            salesChannel: this.getSalesChannel,
            maxResultCount: itemsNumber,
            languagePosition: languagePosition ? languagePosition : 1,
            storesIds: stores,
            currencyId: currencyId,
            ids: null
        }).subscribe(data => {
            this.items = Object.assign([], data.items);
            this.loading = false;
        });
    }
    // Offers Products
    getOffersItems(itemsNumber, languagePosition, currencyId, stores) {
        this.items = [];
        this.loading = true;
        this.itemService[this.isMarketplace ? 'getMarketplace' : 'getList']({
            warehouseId: !this.isMarketplace ? this.storeAppService.currentOutlet?.warehouseId : null,
            branchId: !this.isMarketplace ? this.storeAppService.currentOutlet?.branchId : null,
            sorting: 'date desc',
            offersOnly: true,
            hideOutOfStock: this.storeAppService.storeOptions?.hideOutOfStockItems,
            salesChannel: this.getSalesChannel,
            maxResultCount: itemsNumber,
            languagePosition: languagePosition ? languagePosition : 1,
            storesIds: stores,
            currencyId: currencyId,
            ids: null
        }).subscribe(data => {
            this.items = Object.assign([], data.items);
            this.loading = false;
        });
        ;
    }
    // Bestselling Products 
    getBestsellerItems(itemsNumber, languagePosition, currencyId, stores) {
        this.items = [];
        this.loading = true;
        let mostOrderedObservable = null;
        if (this.isMarketplace) {
            mostOrderedObservable = this.itemService.getMarketplaceMostOrdered({
                maxResultCount: itemsNumber,
                storesIds: stores,
                languagePosition: languagePosition ? languagePosition : 1,
                currencyId: currencyId,
            });
        }
        else {
            mostOrderedObservable = this.itemService.getMostOrdered({
                outletId: this.storeAppService.currentOutlet?.id,
                maxResultCount: itemsNumber,
                languagePosition: languagePosition ? languagePosition : 1,
                currencyId: currencyId,
            });
        }
        mostOrderedObservable.subscribe(data => {
            this.items = Object.assign([], data.items);
            this.loading = false;
        });
    }
    // Category Products 
    getItemsByCategory(categoryId, itemsNumber, languagePosition, currencyId, stores) {
        this.items = [];
        this.loading = true;
        this.itemService[this.isMarketplace ? 'getMarketplace' : 'getList']({
            warehouseId: !this.isMarketplace ? this.storeAppService.currentOutlet?.warehouseId : null,
            branchId: !this.isMarketplace ? this.storeAppService.currentOutlet?.branchId : null,
            sorting: 'date desc',
            categoryId: categoryId,
            hideOutOfStock: this.storeAppService.storeOptions?.hideOutOfStockItems,
            salesChannel: this.getSalesChannel,
            maxResultCount: itemsNumber,
            languagePosition: languagePosition ? languagePosition : 1,
            storesIds: stores,
            currencyId: currencyId,
            ids: null
        }).subscribe(data => {
            this.items = Object.assign([], data.items);
            this.loading = false;
        });
    }
    // selected Products
    getSelectedItems(itemsIds, languagePosition, currencyId, stores) {
        this.items = [];
        this.loading = true;
        this.itemService[this.isMarketplace ? 'getMarketplace' : 'getList']({
            warehouseId: !this.isMarketplace ? this.storeAppService.currentOutlet?.warehouseId : null,
            branchId: !this.isMarketplace ? this.storeAppService.currentOutlet?.branchId : null,
            sorting: 'date desc',
            hideOutOfStock: this.storeAppService.storeOptions?.hideOutOfStockItems,
            salesChannel: this.getSalesChannel,
            maxResultCount: 20,
            ids: itemsIds,
            languagePosition: languagePosition ? languagePosition : 1,
            currencyId: currencyId,
            storesIds: stores,
        }).subscribe(data => {
            this.items = Object.assign([], data.items);
            this.loading = false;
        });
    }
    get getSalesChannel() {
        return SalesChannels.WebStore;
    }
    get isMarketplace() {
        return this.storeAppService.storeConfig.isMarketplace;
    }
}
ItemListAppService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ItemListAppService, deps: [{ token: i1.ItemStoreService }, { token: StoreAppService }], target: i0.ɵɵFactoryTarget.Injectable });
ItemListAppService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ItemListAppService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ItemListAppService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.ItemStoreService }, { type: StoreAppService }]; } });

class PlatformAppService {
    //#endregion
    constructor(platformId) {
        this.platformId = platformId;
        this.isServer = isPlatformServer(this.platformId);
    }
}
PlatformAppService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PlatformAppService, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable });
PlatformAppService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PlatformAppService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PlatformAppService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

class ScreenBreakpointsService {
    //#endregion
    constructor(platformApp) {
        this.platformApp = platformApp;
        //#region vairables
        this.breakpoints = {
            xs: 0,
            sm: 575,
            md: 768,
            lg: 992,
            xl: 1200
        };
    }
    get isSizeSmOrDown() {
        return this.isBrowser ? window.innerWidth <= this.breakpoints.sm : false;
    }
    get isSizeSmOrUp() {
        return this.isBrowser ? window.innerWidth >= this.breakpoints.sm : false;
    }
    get isSizeMdOrDown() {
        return this.isBrowser ? window.innerWidth <= this.breakpoints.md : false;
    }
    get isSizeXlOrUp() {
        return this.isBrowser ? window.innerWidth >= this.breakpoints.xl : false;
    }
    get isSizeLgOrUp() {
        return this.isBrowser ? window.innerWidth >= this.breakpoints.lg : false;
    }
    get isSizeMdOrUp() {
        return this.isBrowser ? window.innerWidth >= this.breakpoints.md : false;
    }
    get isBrowser() {
        return !this.platformApp.isServer;
    }
}
ScreenBreakpointsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ScreenBreakpointsService, deps: [{ token: PlatformAppService }], target: i0.ɵɵFactoryTarget.Injectable });
ScreenBreakpointsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ScreenBreakpointsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ScreenBreakpointsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: PlatformAppService }]; } });

/*
 * Public API Surface of ng.core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BrandsType, CategoriesType, DefaultItemsView, ItemListAppService, ItemsType, NgCoreModule, NgCoreService, PlatformAppService, ScreenBreakpointsService, StoreAppService };
